var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuNiue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#FEDD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H30V22.5H60V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4844 0L45.0469 8.48438L33.6562 0H30V2.90625L41.25 11.2969L30 19.6406V22.5H33.75L45 14.1094L56.2031 22.5H60V19.6875L48.7969 11.3438L60 3V0H56.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.125 13.1719L30 20.625V22.5L42.7031 13.1719H40.125ZM48.75 14.1094L48.4688 15.75L57.4688 22.5H60L48.75 14.1094ZM30 0V0.140625L41.6719 8.95312L41.5781 6.89062L32.3438 0H30ZM60 0L48.7969 8.25H51.6094L60 1.96875V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7031 0V22.5H41.2031V0H48.7031ZM60 7.5V15H30V7.5H60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 9.04688V13.5469H30V9.04688H60ZM47.2031 0V22.5H42.7031V0H47.2031Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0002 15.0748C42.8877 15.0748 41.1752 13.3623 41.1752 11.2498C41.1752 9.13732 42.8877 7.4248 45.0002 7.4248C47.1127 7.4248 48.8252 9.13732 48.8252 11.2498C48.8252 13.3623 47.1127 15.0748 45.0002 15.0748Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 7.42519L42.7504 14.3439L48.6379 10.0689H41.3629L47.2504 14.3439M53.7473 9.21582L52.4348 13.2846L55.8848 10.7814H51.6004L55.0691 13.2939M36.2535 9.21582L34.9316 13.2846L38.391 10.7721H34.1066L37.5754 13.2846M45.0004 16.7158L43.6785 20.7846L47.1473 18.2721H42.8629L46.3316 20.7846M45.0004 1.71582L43.6785 5.78457L47.1473 3.27207H42.8629L46.3316 5.78457",
    fill: "#FEDD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuNiue);
export default __webpack_public_path__ + "static/media/nu Niue.d43e44adfa130d26f029e71dc534b51a.svg";
export { ForwardRef as ReactComponent };